import React from 'react';
import { Page } from '../Common/Components/Page';
import { LabelManagementContent } from './Components/LabelManagementContent';
import { TemplateGroupsProvider } from './Providers/TemplateGroupsProvider';

export const LabelManagement = (): React.JSX.Element => (
  <Page title="Labels" accessKey={'labels'} isSearchable={true}>
    <TemplateGroupsProvider>
      <LabelManagementContent />
    </TemplateGroupsProvider>
  </Page>
);
